import { render } from "./PreciosComponent.vue?vue&type=template&id=52441cfe&scoped=true"
import script from "./PreciosComponent.vue?vue&type=script&lang=js"
export * from "./PreciosComponent.vue?vue&type=script&lang=js"

import "./PreciosComponent.vue?vue&type=style&index=0&id=52441cfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52441cfe"]])

export default __exports__